import { Component, OnInit, Input } from '@angular/core';
import { List } from '../../../core/infrastructure/linq';

@Component({
  selector: 'app-key-words',
  templateUrl: './key-words.component.html',
  styleUrls: ['./key-words.component.scss'],
  standalone: false,
})
export class KeyWordsComponent implements OnInit {
  public keyWord: string;
  @Input('keyWords') public keyWords: string[] = [];
  @Input('isDisabled') public isDisabled: boolean;

  keyWordComaPattern: any = /^[^,]+$/;

  constructor() {}

  ngOnInit(): void {}

  onFormSubmit = function (e) {
    let keyWord = this.keyWord.toLowerCase().trim();

    if (!this.keyWords.includes(keyWord)) {
      this.keyWords.push(keyWord);
    }

    this.keyWord = null;

    e.preventDefault();
  };

  public removeKeyWord(keyWord: string) {
    let data = new List(this.keyWords);
    data.Remove(keyWord.toLowerCase().trim());
    this.keyWords = data.ToArray();
  }
}
